<style lang="scss">

</style>
<!--eslint-disable-->
<template>
  <section>
    <h3 class="text-center">Kiosk Settings</h3>

    <!-- form -->
    <validation-observer ref="kioskValidation">
      <b-form
        class="auth-login-form mt-2"
        @submit.prevent
      >
        <validation-provider
          #default="{ errors }" name="Allow Kiosk" rules="required">
          <b-form-checkbox switch cy="item-allow"
                           v-model="kiosk.allow_kiosk">Allow Kiosk
          </b-form-checkbox>
          <small class="text-danger d-block mb-1">{{ errors[0] }}</small>
        </validation-provider>

        <validation-provider
          #default="{ errors }" name="Allow Social Kiosk" rules="required">
          <b-form-checkbox switch cy="item-allow"
                           v-model="kiosk.allow_kiosk_social">Allow Social Kiosk
          </b-form-checkbox>
          <small class="text-danger d-block mb-1">{{ errors[0] }}</small>
        </validation-provider>

        <validation-provider
          #default="{ errors }" name="Item name" rules="required">
          <label>Max Amount Rule <span
            class="fas fa-info-circle hover"
            data-toggle="tooltip"
            data-placement="top"
            title="Max Value: Maximum monetary value
Max Amount: Maximum number of items"
          ></span></label>
          <b-form-select v-model="kiosk.kiosk_rules.max_amount_type" class="mb-1" cy="item-type"
                         :state="errors.length > 0 ? false:null">
            <option value="MaxValue">Max Value</option>
            <option value="MaxAmount">Max Amount</option>
          </b-form-select>
          <small class="text-danger d-block mb-1">{{ errors[0] }}</small>
        </validation-provider>

        <validation-provider
          #default="{ errors }" name="Max Amount" rules="required">
          <label>Max Amount Value</label>
          <b-form-input
            v-model.number="kiosk.kiosk_rules.max_amount" class="mb-1" cy="item-amount"
            type="number"
            :state="errors.length > 0 ? false:null"
            placeholder="Enter amount"
          />
          <small class="text-danger d-block mb-1">{{ errors[0] }}</small>
        </validation-provider>

        <section class="d-inline-flex full-width mt-2">
          <div class="ui-spacer"></div>
          <b-button class="mr-1" @click="close">Close</b-button>
          <b-button variant="success" @click="validationForm">Update</b-button>
        </section>
      </b-form>
    </validation-observer>
  </section>
</template>
<!--eslint-enable-->

<script>
import KioskService from '@/services/KioskService';
import {mapState} from 'vuex';

export default {
  components: {},
  props: {},
  data() {
    return {
      kiosk: {
        allow_kiosk: false,
        allow_kiosk_social: false,
        kiosk_rules: {
          max_amount_type: 'MaxValue',
          max_amount: '',
        },
      }
    };
  },
  watch: {
    prison: {
      deep: true,
      handler() {
        this.presetKioskSettings()
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
    }),
  },
  mounted() {
    this.presetKioskSettings();
  },
  methods: {
    presetKioskSettings() {
      this.kiosk.allow_kiosk = this.prison.allow_kiosk;
      this.kiosk.allow_kiosk_social = this.prison.allow_kiosk_social;
      this.kiosk.kiosk_rules = {...this.prison.kiosk_rules};
    },
    validationForm() {
      this.$refs.kioskValidation.validate()
        .then(success => {
          if (success) {
            this.updateKiosk();
          }
        })
    },
    updateKiosk() {
      KioskService.updateKioskSettings(this.prison.prison_id, this.kiosk).then(() => {
        this.$toast.success('Kiosk settings successfully updated', {
          toastClassName: ['toast-std', 'success-toast'],
        });
        this.close();
      }).catch(err => {
        this.$toast.error('Something went wrong updating the kiosk settings, please refresh the page and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    close() {
      this.$emit('close', true);
    }
  },
};
</script>
